import React from 'react';
import katex from 'katex';
import 'katex/dist/katex.min.css';

const MathSample = ({ children }) => <span dangerouslySetInnerHTML={{ __html: katex.renderToString(children, { throwOnError: false, output: 'html' }) }} />;

// Illustrative worksheet layouts, using the same maths renderer as the editor.
export default function WorksheetStylePreview({ style }) {
  const title = { clean: 'Number practice', exam: 'Algebra assessment', guided: 'Area & perimeter' }[style];
  return <div className={`cp-paper-preview cp-paper-preview--${style}`} aria-hidden="true">
    <b className="cp-paper-title">{title}</b>
    <div className="cp-paper-details">Name: ______________ Date: ________</div>
    {style === 'clean' && <>
      <small>Calculate each answer.</small>
      <div className="cp-preview-number-grid">{['245 + 138 = \\rule{1.4em}{0.4pt}', '608 - 274 = \\rule{1.4em}{0.4pt}', '36 \\div 4 = \\rule{1.4em}{0.4pt}', '7 \\times 8 = \\rule{1.4em}{0.4pt}', '\\frac{3}{4} \\text{ of } 20 = \\rule{1.4em}{0.4pt}', '54 + 29 = \\rule{1em}{0.4pt}', '9 \\times 6 = \\rule{1em}{0.4pt}', '72 \\div 8 = \\rule{1em}{0.4pt}', '125 - 48 = \\rule{1em}{0.4pt}'].map((math, i) => <div className="cp-paper-question" key={math}>{i + 1}. <MathSample>{math}</MathSample></div>)}</div>
    </>}
    {style === 'exam' && <>
      <small>Show your working for each question.</small>
      <div className="cp-paper-question">1. Simplify <MathSample>{'3x + 2x - 4'}</MathSample>.</div>
      <div className="cp-paper-question">2. Solve <MathSample>{'2x + 5 = 17'}</MathSample>.</div>
      <div className="cp-paper-question">3. Expand <MathSample>{'4(x + 3)'}</MathSample>.</div>
    </>}
    {style === 'guided' && <>
      <div className="cp-paper-question">1. Find the area of this rectangle.
        <div className="cp-preview-diagram"><span><MathSample>{'8\\,\\mathrm{cm}'}</MathSample></span><div className="cp-preview-rectangle" /><span><MathSample>{'3\\,\\mathrm{cm}'}</MathSample></span></div>
      </div>
      <div className="cp-paper-question">2. Find its perimeter.</div>
    </>}
  </div>;
}
